module.exports = __webpack_public_path__ + "static/image-optim-37aa76727fe6173a4287a6773ccd248c.jpg";